import React, { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { SalaryCardFormSchema } from 'pages/Orders/SalaryCardOrder/models/salaryCardOrder.schema'
import {
  CardCurrenyType,
  CardType,
  OrderDeliveryType,
  OrderType,
} from '../../constants/fieldValues.constant'
import { OrderSalaryCardType } from 'store/types/salaryCard'
import { useFetchEmployeeInfoExcel } from 'pages/Orders/SalaryCardOrder/models/useFetchEmployeeInfoExcel'
import UploadEmployee from './blocks/UploadEmployee'
import CompanyInfoForm from './blocks/CompanyInfoForm'
import EmployeeTableForm from './blocks/EmployeeTableForm'
import OrderFormFooter from './blocks/OrderFormFooter'
import { Divider, Row } from 'antd'
import { resetSalaryExcel } from 'store/actions/salaryCard'
import { useDispatch } from 'react-redux'

function SalaryCardOrderForm() {
  const methods = useForm<
    OrderSalaryCardType & { formStatus: any; trustedPersonValid: boolean }
  >({
    mode: 'all',
    resolver: yupResolver(SalaryCardFormSchema()),
    defaultValues: {
      trustedPerson: {
        id: null,
        fullName: '',
        phone: '',
        pin: '',
        expiryDate: '',
      },
      cardCurrency: CardCurrenyType.AZN,
      cardType: CardType.VISA,
      orderType: OrderType.ORDINARY,
      orderDeliveryType: OrderDeliveryType.BANK,
      // trustedPersonValid: false,
      tableList: [],
    },
  })

  const { status, salaryCardListExcel } = useFetchEmployeeInfoExcel()
  const dispatch = useDispatch()

  useEffect(() => {
    if (status === 'success') {
      methods.setValue('tableList', salaryCardListExcel)
    }
  }, [status])

  useEffect(() => {
    return () => {
      dispatch(resetSalaryExcel())
    }
  }, [])

  return (
    <FormProvider {...methods}>
      <Row style={{ flexDirection: 'column' }} gutter={[0, 24]}>
        <CompanyInfoForm />
        <Divider />
      </Row>
      <UploadEmployee type="create" />
      <Divider />
      <EmployeeTableForm />
      <OrderFormFooter type="create" />
    </FormProvider>
  )
}

export default SalaryCardOrderForm
